
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { popularTags, topUsers } from '../../../mocks/community';
import { jobListData } from '../../../mocks/jobList';

export default function CommunitySidebar() {
  const navigate = useNavigate();
  const topJobs = jobListData.filter((j) => j.isHot).slice(0, 3);

  const rankColors = ['text-yellow-400', 'text-gray-300', 'text-amber-600'];
  const rankBg = ['bg-yellow-500/10', 'bg-gray-400/10', 'bg-amber-600/10'];

  return (
    <aside className="w-72 flex-shrink-0">
      <div className="sticky top-28 space-y-6">
        {/* Hot Jobs Widget */}
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          className="bg-gradient-purple rounded-2xl border border-white/10 p-5"
        >
          <h4 className="text-sm font-bold text-white mb-4 flex items-center gap-2">
            <a href="/jobs" onClick={(e) => { e.preventDefault(); navigate('/jobs'); }} className="hover:text-neon-purple transition-colors">
              <i className="ri-briefcase-line w-4 h-4 flex items-center justify-center text-neon-purple"></i>
              HOT 채용 공고
            </a>
          </h4>
          <div className="space-y-3">
            {topJobs.map((job) => (
              <a
                key={job.id}
                href={`/job/${job.id}`}
                onClick={(e) => { e.preventDefault(); navigate(`/job/${job.id}`); }}
                className="flex items-center gap-3 p-2.5 rounded-xl bg-white/5 hover:bg-white/10 transition-all cursor-pointer group"
              >
                <div className="w-10 h-10 rounded-lg overflow-hidden flex-shrink-0">
                  <img src={job.image} alt={job.position} className="w-full h-full object-cover" />
                </div>
                <div className="min-w-0">
                  <p className="text-xs font-semibold text-white truncate group-hover:text-neon-purple transition-colors">
                    {job.position}
                  </p>
                  <p className="text-[10px] text-gray-500">{job.company} · {job.location}</p>
                </div>
              </a>
            ))}
          </div>
          <a
            href="/jobs"
            onClick={(e) => { e.preventDefault(); navigate('/jobs'); }}
            className="block text-center text-xs text-neon-pink mt-4 hover:underline cursor-pointer"
          >
            전체 채용 보기 &rarr;
          </a>
        </motion.div>

        {/* Popular Tags */}
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="bg-white/5 backdrop-blur-md rounded-2xl border border-white/10 p-5"
        >
          <h4 className="text-sm font-bold text-white mb-4 flex items-center gap-2">
            <a href="#tags" className="hover:text-neon-purple transition-colors">
              <i className="ri-price-tag-3-line w-4 h-4 flex items-center justify-center text-neon-purple"></i>
              인기 태그
            </a>
          </h4>
          <div className="flex flex-wrap gap-2">
            {popularTags.map((tag) => (
              <span
                key={tag}
                className="text-[11px] text-gray-400 bg-white/5 hover:bg-neon-purple/10 hover:text-neon-purple px-3 py-1.5 rounded-lg transition-all cursor-pointer"
              >
                #{tag}
              </span>
            ))}
          </div>
        </motion.div>

        {/* Top Users */}
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="bg-white/5 backdrop-blur-md rounded-2xl border border-white/10 p-5"
        >
          <h4 className="text-sm font-bold text-white mb-4 flex items-center gap-2">
            <a href="#top-users" className="hover:text-neon-purple transition-colors">
              <i className="ri-trophy-line w-4 h-4 flex items-center justify-center text-yellow-400"></i>
              이주의 활동왕
            </a>
          </h4>
          <div className="space-y-3">
            {topUsers.map((user) => (
              <div key={user.rank} className="flex items-center gap-3">
                <div className={`w-7 h-7 flex items-center justify-center rounded-lg text-xs font-bold ${rankBg[user.rank - 1]} ${rankColors[user.rank - 1]}`}>
                  {user.rank}
                </div>
                <div className="w-8 h-8 rounded-full overflow-hidden">
                  <img src={user.avatar} alt={user.name} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-xs font-semibold text-white truncate">{user.name}</p>
                  <div className="flex items-center gap-2 mt-1">
                    <div className="flex-1 h-1 bg-white/5 rounded-full overflow-hidden">
                      <div
                        className="h-full bg-gradient-neon rounded-full"
                        style={{ width: `${(user.score / 3000) * 100}%` }}
                      ></div>
                    </div>
                    <span className="text-[10px] text-gray-500">{user.score.toLocaleString()}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </aside>
  );
}
